import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { SmallCurrencyLogo } from '../CurrencyLogo' 
import { coinImage } from '../../assets/coins/coins'
import { MouseoverTooltip } from './ToolTip'
import { rewardsDocsURI } from '../../config'


const RewardsStyle = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  color: ${({ theme }) => theme.rewardsColor};
  background: ${({ theme }) => theme.rewardsBackgroundColor};
  border: 1px solid ${({ theme }) => theme.rewardsBorderColor};
  border-radius:14px;
  padding:0.5rem;
  cursor:pointer;
  font-size:1.4rem;
  opacity: 0.9;
`

export function Rewards() {
  return (
    <div> 
      <MouseoverTooltip
        text={
          <div 
            style={{
              display:'flex',
              flexDirection:'column',
              textAlign:'left',
              cursor:'text',
              fontFamily:'Montserrat-Light',
              fontWeight:'normal'
          }}
          >
            <span>{'By LPing into this pool, you will be able to claim Swaap tokens when they will be released.'}</span>
            <span style={{height:'0.65rem'}}>{' '}</span>
            <div>
              <span>Click</span>
              <a 
                target="_blank" 
                rel="noopener noreferrer" 
                href={rewardsDocsURI} 
                className="link"
                style={{
                  margin:'0 0.3rem'
                }}
              >
                here
              </a>
              <span >for more information.</span>
            </div>
          </div>
        }
        disableHover={false}
        show={false}
      >
        <RewardsStyle>
          <span>+</span>
          <span style={{width:'0.25rem'}}>{' '}</span>
          <SmallCurrencyLogo
            key={'swaap'}
            src={coinImage('swaap')!}
          />
          <span>coins</span>
        </RewardsStyle>
      </MouseoverTooltip>
    </div>
  )
}